// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__28kni","cardHeader":"styles_cardHeader__iNNTA"};